import ko from 'knockout';

ko.extenders.pathInObject = (target, options) => {
	target.pathInObject = options;
};
